<div class="grouped-dropdown">
  <label *ngIf="label" class="dropdown-label">{{ label }}</label>

  <button
    type="button"
    class="dropdown-trigger input bg-white dark:bg-coal-700"
    [class.has-value]="selectedValues.length > 0"
    [disabled]="disabled"
    (click)="toggleDropdown()"
  >
    <span class="dropdown-value">{{ selectedLabel }}</span>
    <span
      *ngIf="selectedValues.length > 0"
      class="clear-selection"
      aria-label="Clear selection"
      (click)="clearSelection($event)"
    >
      &times;
    </span>
    <span class="dropdown-arrow" [class.open]="isOpen"></span>
  </button>

  <div
    *ngIf="isOpen"
    class="dropdown-panel bg-white dark:bg-coal-700"
    (click)="$event.stopPropagation()"
  >
    <div class="search-row bg-white dark:bg-coal-700">
      <span class="search-icon"></span>
      <input
        type="text"
        class="search-input"
        [(ngModel)]="searchText"
        [placeholder]="searchPlaceholder"
        autocomplete="off"
      />
    </div>

    <ng-container *ngIf="filteredGroups.length > 0; else emptyState">
      <div *ngFor="let group of filteredGroups" class="option-group">
        <div class="group-heading">{{ group.heading }}</div>

        <button
          *ngFor="let option of group.options"
          type="button"
          class="dropdown-option"
          [class.selected]="isSelected(option)"
          [disabled]="option.disabled"
          (click)="selectOption(option)"
        >
          <input
            *ngIf="multiSelect"
            type="checkbox"
            class="option-checkbox"
            [checked]="isSelected(option)"
            tabindex="-1"
          />
          <span class="option-label">{{ option.label }}</span>
          <span
            *ngIf="!multiSelect && isSelected(option)"
            class="selected-mark"
            aria-hidden="true"
          ></span>
        </button>
      </div>
    </ng-container>

    <ng-template #emptyState>
      <div class="empty-state">No results found</div>
    </ng-template>
  </div>
</div>
